import {SectionHeader} from './section-header';

import styles from './command-palette.module.css';

interface Props {
    title: string;
    children: React.ReactNode;
}

export function ResultSection(props: Props) {
    return (
        <div className={styles['result-section']}>
            <SectionHeader>{props.title}</SectionHeader>
            {props.children}
        </div>
    );
}
